import type { FC } from "react";
import { EmptyStateCard } from "@/components/podkit/EmptyStateCard";
import { IconPlus } from "@/assets/icons/geist/IconPlus";
import { Button } from "@/components/flexkit/Button";
import { Link } from "react-router-dom";
import { AutomationStepList } from "@/components/automations/AutomationStepList";
import { StepListContainer } from "@/routes/automations/automation-details-page/StepListContainer";
import type {
    WorkflowEditFormStepData,
    WorkflowEditFormTriggerData,
    WorkflowEditFormLimitsData,
} from "@/components/automations/automation-edit-form-data";
import { workflowDetailsEditUrl } from "@/utils/automations";
import type { PlainMessage } from "@bufbuild/protobuf";
import type { Subject } from "gitpod-next-api/gitpod/v1/identity_pb";

export const AutomationDefinitionSectionView: FC<{
    workflowId: string;
    trigger?: WorkflowEditFormTriggerData;
    steps: WorkflowEditFormStepData[];
    limits?: WorkflowEditFormLimitsData;
    executor?: PlainMessage<Subject>;
}> = ({ workflowId, trigger, steps, limits, executor }) => {
    if (steps.length === 0) {
        return (
            <EmptyStateCard
                title="Define your automation"
                description="Begin by describing what should happen when this automation is run."
                data-testid="workflow-executions-empty-state"
            >
                <Button asChild variant="primary" LeadingIcon={IconPlus} data-tracking-id="run-workflow-empty-state">
                    <Link to={workflowDetailsEditUrl({ id: workflowId })}>Add Step</Link>
                </Button>
            </EmptyStateCard>
        );
    }

    return (
        <StepListContainer>
            <div className="flex w-full max-w-screen-xl flex-row items-start justify-center gap-4">
                <AutomationStepList trigger={trigger} limits={limits} steps={steps} executor={executor} />
            </div>
        </StepListContainer>
    );
};
